import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { IColors } from '@src/types/theme';
import * as selectors from '@src/store/selectors';
import { PROGRESS_STATUS_IN_PROGRESS, PROGRESS_STATUS_UNDONE } from '@src/const/course';

const ProgressLineWrapper = styled.div`
	position: relative;
	top: ${props => `-${props.index * 8 * 2 + 8}px`};
	left: 7px;
	display: flex;
	align-items: center;
`;

const Line = styled.div`
	width: 2px;
	height: ${props => ((props.status === PROGRESS_STATUS_IN_PROGRESS) ? '107px' : '30px')};
	margin-right: 16px;
	background: ${props => props.backgroundColor};
`;

interface IProgressLine {
	index: number;
	status: string;
	children: JSX.Element;
}

const ProgressLine = ({ index, status, children }: IProgressLine): JSX.Element => {
	const { colors } = useSelector(selectors.getColorTheme) as { colors: IColors };
	let backgroundColor = colors.primary;

	if (status === PROGRESS_STATUS_IN_PROGRESS) {
		backgroundColor = `linear-gradient(to bottom, ${colors.primary}, #DDDDDD)`;
	} else if (status === PROGRESS_STATUS_UNDONE) {
		backgroundColor = '#DDDDDD';
	}

	return (
		<ProgressLineWrapper index={index}>
			<Line status={status} backgroundColor={backgroundColor} />
			{children}
		</ProgressLineWrapper>
	);
};

export default ProgressLine;
